<div
  [attr.id]="module.slug || null"
  [attr.data-ancnav]="module.slug || null"
  class="content-module image-module"
  [attr.data-decorate]="module.hasDecoration"
  [attr.data-description]="hasDescription"
>
  <div class="image-module__inner">

    <div class="image-module__top" *ngIf="module.legend">
      <p class="subtitle--tri image-module__legend">{{ module.legend }}</p>
    </div>

    <img [src]="module.image.url" [attr.alt]="module.image.alt || null" class="image-module__img">

    <div class="image-module__bottom" *ngIf="module.title || module.description">
      <div class="image-module__bottom-inner">
        <p class="subtitle--two image-module__title" *ngIf="module.title">{{ module.title }}</p>
        <div class="image-module__description" *ngIf="module.description">
          <app-wysiwyg-content [content]="module.description"></app-wysiwyg-content>
        </div>
        <div class="image-module__source" *ngIf="module.source && module.description">
          <a [href]="module.source" target="_blank" class="link link--small link--active image-module__source-link">
            <span class="link__text">source</span>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="image-module__source" *ngIf="module.source && !module.description">
    <a [href]="module.source" target="_blank" class="link link--small link--active image-module__source-link">
      <span class="link__text">source</span>
    </a>
  </div>
</div>
